import React from "react";
import { Form, List, Space, Typography, InputNumber } from "antd";

const { Text } = Typography;

/**
 * @description Sección de totales de la factura
 */
const TotalesSection = ({ disabled = false, tipoFactura }) => {
    return (
        <List className="list-totals" size="small" bordered={false}>
            {/* SubTotal */}
            <List.Item>
                <Space style={{ justifyContent: "space-between", width: "100%" }}>
                    <Text strong>SubTotal <small className="text-gray">(suma de importes)</small></Text>
                    <Form.Item name="SubTotal" noStyle>
                        <InputNumber
                            size="large"
                            controls={false}
                            style={{ minWidth: 150 }}
                            formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            bordered={false}
                        />
                    </Form.Item>
                </Space>
            </List.Item>

            {/* Descuento - Solo para Nota de Crédito */}
            {tipoFactura === "NC" && (
                <List.Item>
                    <Space style={{ justifyContent: "space-between", width: "100%" }}>
                        <Text strong>Descuento</Text>
                        <Form.Item name="Descuento" noStyle>
                            <InputNumber
                                size="large"
                                controls={false}
                                disabled
                                style={{ minWidth: 150 }}
                                formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                bordered={false}
                            />
                        </Form.Item>
                    </Space>
                </List.Item>
            )}

            {/* Total Impuestos Trasladados */}
            <List.Item>
                <Space style={{ justifyContent: "space-between", width: "100%" }}>
                    <Text strong>Total Impuestos Trasladados (IVA) (16%)</Text>
                    <Form.Item name="ImpuestosBase" noStyle>
                        <InputNumber
                            style={{ display: 'none' }}
                            size="large"
                            controls={false}
                            formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            disabled={disabled}
                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            bordered={false}
                        />
                    </Form.Item>
                    <Form.Item name={["Impuestos", "TotalImpuestosTrasladados"]} noStyle>
                        <InputNumber
                            size="large"
                            controls={false}
                            style={{ minWidth: 150 }}
                            formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            bordered={false}
                        />
                    </Form.Item>
                </Space>
            </List.Item>

            {/* Total */}
            <List.Item>
                <Space style={{ justifyContent: "space-between", width: "100%" }}>
                    <Text strong>Total</Text>
                    <Form.Item name="Total" noStyle>
                        <InputNumber
                            size="large"
                            controls={false}
                            style={{ minWidth: 150 }}
                            formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            bordered={false}
                        />
                    </Form.Item>
                </Space>
            </List.Item>
        </List>
    );
};

export default TotalesSection;
